import { render, staticRenderFns } from "./PublishingCompanyShow.vue?vue&type=template&id=fa8d1792"
import script from "./PublishingCompanyShow.vue?vue&type=script&lang=js"
export * from "./PublishingCompanyShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports